<template>
  <div>
    <AdvanceFilter
      @filter-applied="onFilterApplied"
      :currentView="currentView"
      :sortLabel="sortLabel"
      @setView="setView"
      @toggleSort="toggleSort"
      @resetFilters="resetFilters"
    />
    <Views
      ref="viewsRef"
      :filters="filters"
      :initial-services="initialServices"
      :initial-total="initialTotal"
      @restore-filters="onRestoreFilters"
      @view-changed="onViewChanged"
      @sort-changed="onSortChanged"
    />
  </div>
</template>

<script>
import Views from './Views.vue';
import AdvanceFilter from './AdvanceFilter.vue';
import '../../../public/css/main.css'
import { EventBus } from "../../services/EventBus.js";
export default {
  components: {
    Views,
    AdvanceFilter
  },
  props: {
    initialServices: {
      type: Array,
      default: () => [],
    },
    initialTotal: {
      type: Number,
      default: 0,
    },
  },
data() {
  return {
    currentView: "grid",
    sortLabel: "Newest",
    filters: {
      selectedServiceType: EventBus.selectedServiceType || '',
      selectedSubType: EventBus.selectedSubtype || '',
      userinput: '',
      distance: '',
      withPhotosOnly: false,
      preferredCountryName: EventBus.selectedCountryName || '',
    }
  };
},
mounted() {
  // Keep filters.preferredCountryName in sync with EventBus so later
  // interactions (pagination, sort, filter chips) don't drop the country
  // by re-spreading filters with a stale value. Views' country watcher
  // owns the actual refetch — this only mirrors state into the prop.
  this._countryWatcher = this.$watch(
    () => EventBus.selectedCountryName,
    (newCountry) => {
      this.filters = { ...this.filters, preferredCountryName: newCountry || '' };
    }
  );
},
beforeUnmount() {
  if (this._countryWatcher) this._countryWatcher();
},
  methods: {
  onFilterApplied(filters) {
  this.filters = {
    ...this.filters,
    ...filters
  };
},

  onRestoreFilters(filters) {
    // Sanitize userinput: stale sessionStorage (saved before a previous fix) may
    // have stored the raw {lat,lng,label} object instead of a plain string.
    // Always extract the string so EventBus and the filters object stay clean.
    const rawInput = filters.userinput;
    const userinput =
      typeof rawInput === 'string'
        ? rawInput
        : rawInput && typeof rawInput === 'object'
          ? rawInput.label || ''
          : '';

    const sanitized = { ...filters, userinput };

    this.filters = {
      ...this.filters,
      ...sanitized,
    };

    // propagate to EventBus so AdvanceFilter updates UI. Rebuild the
    // {lat,lng,label} object form when coords were persisted so a follow-up
    // search from AdvanceFilter keeps the geo scope — otherwise the next
    // handleSearch() sees a plain string and drops the coords, turning a
    // location-scoped result back into an unscoped one.
    if (sanitized.latOverride && sanitized.lngOverride) {
      EventBus.selectedLocation = {
        lat: sanitized.latOverride,
        lng: sanitized.lngOverride,
        label: userinput || "",
      };
    } else {
      EventBus.selectedLocation = userinput || "";
    }
    if (sanitized.preferredCountryName) {
      EventBus.selectedCountryName = sanitized.preferredCountryName;
    }
    EventBus.selectedSubtype = sanitized.selectedSubType || "";
    EventBus.selectedServiceType = sanitized.selectedServiceType || "";
    EventBus.withPhotosOnly = sanitized.withPhotosOnly === true;
    // Restore distance so the AdvanceFilter "Near" dropdown re-populates after
    // back-from-detail. Without this, AdvanceFilter.distance stays "" and any
    // follow-up handleSearch (category chip, photo toggle, etc.) emits filters
    // with a different distance than was actually applied, giving a different
    // result count from the one the user just came back from.
    if (sanitized.distance) {
      EventBus.selectedDistance = sanitized.distance;
    }
  },

  onViewChanged(view) {
    this.currentView = view;
  },

  onSortChanged(label) {
    this.sortLabel = label;
  },

  setView(view) {
    this.$refs.viewsRef?.setView(view);
  },

  toggleSort() {
    this.$refs.viewsRef?.cycleSortOrder();
  },

  resetFilters() {
    this.$refs.viewsRef?.resetFilters();
  },
  },
}

</script>

<style scoped>
</style>
